import React from 'react'
import SymbolHeading from '../components/SymbolHeading'
import Teaser from '../components/Teaser'
import Star from '../assets/star.svg?svgr-webpack'
import { TeaserFragment } from './../components/types/TeaserFragment'
import { NonNullableObject } from 'typings'

type Props = {
  stories: NonNullableObject<TeaserFragment>[]
}

export default function FeaturedStories({ stories }: Props) {
  if (stories.length === 0) return null

  return (
    <div className="o-width-limiter mb-48 md:mb-64 lg:mb-80 xl:mb-96">
      <SymbolHeading symbol={Star}>Featured stories</SymbolHeading>
      <div className="justify-center md:flex">
        {stories.map((story) => {
          return (
            <div
              key={story.id}
              className="mb-32 md:mx-12 md:mb-0 md:w-1/3 lg:mx-24"
            >
              <Teaser {...story} big />
            </div>
          )
        })}
      </div>
    </div>
  )
}
